import { nullSafeToString, toDisplayPrice } from '../lib/util';

/**
 * A loyalty coupon redeemed against an {@link Order Order}.
 *
 * Only an active coupon is returned - OrdersProvider#findLoyaltyCouponByOrderId treats an inactive one
 * as absent, so a coupon that was later voided reads the same as an order that never had one.
 *
 * @property {number} id - (Read only) This coupon's unique id.
 * @property {string} code - (Read only) The coupon code that was redeemed.
 * @property {number} discountAmount - (Read only) How much the coupon took off the order.
 * @property {string} displayDiscountAmount - (Read only) this.discountAmount formatted with commas and two decimal places.
 */

class OrderLoyaltyCoupon {
    constructor (data = {}) {
        this.id = data.id;
        this.code = nullSafeToString(data.code);
        this.discountAmount = data.discountAmount || 0;
        this.displayDiscountAmount = toDisplayPrice(this.discountAmount);

        Object.freeze(this);
    }
}

export default OrderLoyaltyCoupon;
